<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="tasks"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column fixed type="index" width="50" fixed></el-table-column>
      <el-table-column prop="name" label="名称" width="300" fixed></el-table-column>
      <el-table-column prop="jobGroup" label="任务组" width="150"></el-table-column>
      <el-table-column prop="triggerType" label="任务类型" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.triggerType==1  ? 'success' : ''"
            disable-transitions
          >{{scope.row.triggerType==1 ? "Cron":"Simple"}}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="isStart" label="状态-数据库" width="120">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.isStart  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.isStart ? "运行中":"停止"}}</el-tag>
        </template>
      </el-table-column>  

      <el-table-column prop="triggers"  label="状态-内存" width="120">
        <template slot-scope="scope">
          <el-tag
              :type="(scope.row.triggers[0].triggerStatus=='正常')  ? 'success' : 'danger'"
              disable-transitions
            >{{scope.row.triggers[0].triggerStatus}}</el-tag>
        </template>
      </el-table-column> 

      <el-table-column prop="cron" label="Cron表达式" width="120"></el-table-column>
      <el-table-column prop="runTimes" label="累计运行(次)" width="120"></el-table-column>
       <el-table-column prop="intervalSecond" label="循环周期(秒)" width="120" ></el-table-column>
        <el-table-column prop="cycleRunTimes" label="循环次数(次)" width="120"></el-table-column>
      <el-table-column prop="assemblyName" label="程序集" width="150"></el-table-column>
      <el-table-column prop="className" label="执行类" width="250"></el-table-column>
      <el-table-column prop="beginTime" label="开始时间" :formatter="formatBeginTime" width="90" ></el-table-column>
      <el-table-column prop="endTime" label="结束时间" :formatter="formatEndTime" width="90"></el-table-column>
      
    <el-table-column
      label="日志" >
      <template slot-scope="scope">
        <el-popover trigger="hover" placement="top">
          <p v-html="scope.row.remark"></p>
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium">Log</el-tag>
          </div>
        </el-popover>
      </template>
    </el-table-column>

    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
        <el-form-item label="任务组" prop="jobGroup">
          <el-input v-model="editForm.jobGroup" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
         <el-form-item label="程序集" prop="assemblyName">
          <el-input v-model="editForm.assemblyName" auto-complete="off"></el-input>
        </el-form-item>
         <el-form-item label="执行类名" prop="className">
          <el-input v-model="editForm.className" auto-complete="off"></el-input>
        </el-form-item>
        
        <el-form-item prop="triggerType" label="是否Cron" width="" sortable>
            <el-switch v-model="editForm.triggerType" >
            </el-switch>
            <span style="float:right;color: #aaa;">(1：Cron模式，0：Simple模式)</span> 
        </el-form-item>
        
        <el-form-item label="Cron表达式" v-if="editForm.triggerType" prop="Cron">
           <el-tooltip placement="top">
            <div slot="content">
                 每隔5秒执行一次：*/5 * * * * ?<br >
                 每隔1分钟执行一次：0 */1 * * * ?<br >
                 每天23点执行一次：0 0 23 * * ?<br >
                 每天凌晨1点执行一次：0 0 1 * * ?<br >
                 每月1号凌晨1点执行一次：0 0 1 1 * ?<br >
                 每月最后一天23点执行一次：0 0 23 L * ?<br >
                 每周星期天凌晨1点实行一次：0 0 1 ? * L<br >
                 在26分、29分、33分执行一次：0 26,29,33 * * * ?<br >
                 每天的0点、13点、18点、21点都执行一次：0 0 0,13,18,21 * * ?<br >
            </div>
          <el-input v-model="editForm.cron" auto-complete="off"></el-input>
         </el-tooltip>
        </el-form-item>
        <el-form-item label="循环周期" v-else prop="intervalSecond">
          <el-input-number v-model="editForm.intervalSecond"  :min="1" style="width:200px;" auto-complete="off"></el-input-number>
            <span style="float:right;color: #aaa;">(单位：秒)</span> 
        </el-form-item>
        <el-form-item label="循环次数" v-if="!editForm.triggerType" prop="cycleRunTimes">
          <el-tooltip placement="top">
            <div slot="content">
                 设置成0时,就意味着无限制次数运行
            </div>
           <el-input-number v-model="editForm.cycleRunTimes"  :min="0" style="width:200px;" auto-complete="off"></el-input-number>
         </el-tooltip> 
            <span style="float:right;color: #aaa;">(单位：次)</span> 
        </el-form-item>
        <el-form-item label="是否激活" prop="isStart">
          <el-switch v-model="editForm.isStart" >
            </el-switch>
        </el-form-item>

        <el-form-item label="开始时间" prop="beginTime">
            <el-date-picker type="datetime" placeholder="选择日期" v-model="editForm.beginTime" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
            <el-date-picker type="datetime" placeholder="选择日期" v-model="editForm.endTime" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
         <el-form-item label="任务组" prop="jobGroup">
          <el-input v-model="addForm.jobGroup" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
         <el-form-item label="程序集" prop="assemblyName">
          <el-input v-model="addForm.assemblyName" auto-complete="off"></el-input>
        </el-form-item>
         <el-form-item label="执行类名" prop="className">
          <el-input v-model="addForm.className" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item prop="triggerType" label="是否Cron" width="" sortable>
            <el-switch v-model="addForm.triggerType" >
            </el-switch>
            <span style="float:right;color: #aaa;">(1：Cron模式，0：Simple模式)</span> 
        </el-form-item>
        
        <el-form-item label="Cron表达式"  v-if="addForm.triggerType" prop="Cron">
          <el-tooltip placement="top">
            <div slot="content">
                 每隔5秒执行一次：*/5 * * * * ?<br >
                 每隔1分钟执行一次：0 */1 * * * ?<br >
                 每天23点执行一次：0 0 23 * * ?<br >
                 每天凌晨1点执行一次：0 0 1 * * ?<br >
                 每月1号凌晨1点执行一次：0 0 1 1 * ?<br >
                 每月最后一天23点执行一次：0 0 23 L * ?<br >
                 每周星期天凌晨1点实行一次：0 0 1 ? * L<br >
                 在26分、29分、33分执行一次：0 26,29,33 * * * ?<br >
                 每天的0点、13点、18点、21点都执行一次：0 0 0,13,18,21 * * ?<br >
            </div>
          <el-input v-model="addForm.cron" auto-complete="off"></el-input>
         </el-tooltip>

        </el-form-item>
        <el-form-item label="循环周期" v-else  prop="intervalSecond">
          <el-input-number v-model="addForm.intervalSecond"  :min="1" style="width:200px;" auto-complete="off"></el-input-number>
            <span style="float:right;color: #aaa;">(单位：秒)</span> 
        </el-form-item>
        <el-form-item label="循环次数" v-if="!addForm.triggerType" prop="cycleRunTimes">
          <el-tooltip placement="top">
            <div slot="content">
                 设置成0时,就意味着无限制次数运行
            </div>
           <el-input-number v-model="editForm.cycleRunTimes"  :min="0" style="width:200px;" auto-complete="off"></el-input-number>
         </el-tooltip> 
            <span style="float:right;color: #aaa;">(单位：次)</span> 
        </el-form-item>
        <el-form-item label="是否激活" prop="isStart">
          <el-switch v-model="addForm.isStart" >
            </el-switch>
        </el-form-item>

        <el-form-item label="开始时间" prop="beginTime">
            <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.beginTime" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
            <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.endTime" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getTaskListPage, removeTask, editTask, addTask,startJob, stopJob, reCovery ,pauseJob,resumeJob} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: ""
      },
      buttonList: [],
      tasks: [],
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        jobGroup: [{ required: true, message: "请输入组名", trigger: "blur" }],
        name: [{ required: true, message: "请输入Job名", trigger: "blur" }],
        beginTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
        assemblyName: [{ required: true, message: "请输入程序集名", trigger: "blur" }],
        className: [{ required: true, message: "请输入执行的Job类名", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        id: 0,
        name: "",
        jobGroup: "",
        TriggerType: 1,
        cron: "",
        intervalSecond: 0,
        beginTime: "",
        endTime: "",
        assemblyName: "",
        className: "",
        remark: "",
        jobParams:"",
        isDeleted:false,
        isStart: false
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        jobGroup: [{ required: true, message: "请输入组名", trigger: "blur" }],
        name: [{ required: true, message: "请输入Job名", trigger: "blur" }],
        beginTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
        assemblyName: [{ required: true, message: "请输入程序集名", trigger: "blur" }],
        className: [{ required: true, message: "请输入执行的Job类名", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        id: 0,
        name: "",
        jobGroup: "",
        triggerType: 1,
        cron: "",
        intervalSecond: 0,
        beginTime: "",
        endTime: "",
        assemblyName: "",
        className: "",
        jobParams:"",
        remark: "",
        isDeleted:false,
        isStart: false
      },
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '一月后(30)',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }, {
            text: '一年后(365)',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            }
          }]
        }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.func].apply(this, item);
    },
    formatCreateTime: function(row, column) {
      return !row.createTime || row.createTime == ""
        ? ""
        : util.formatDate.format(new Date(row.createTime), "yyyy-MM-dd hh:mm:ss");
    },
    formatBeginTime: function(row, column) {
      return !row.beginTime || row.beginTime == ""
        ? ""
        : util.formatDate.format(new Date(row.beginTime), "yyyy-MM-dd hh:mm:ss");
    },
    formatEndTime: function(row, column) {
      return !row.endTime || row.endTime == ""
        ? ""
        : util.formatDate.format(new Date(row.endTime), "yyyy-MM-dd hh:mm:ss");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTasks();
    },
    //获取用户列表
    getTasks() {
      let _this = this;
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;
      //NProgress.start();
      getTaskListPage(para).then(res => {
        this.total = res.data.response.total;
        this.tasks = res.data.response.pageData;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      if (row.triggerType==1) {
          row.triggerType=true
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            if (para.triggerType) {
                para.triggerType=1;
            }else{
                para.triggerType=0;
            }
            editTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getTasks();
              } else {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            var user = JSON.parse(window.localStorage.user);

            if (user && user.id > 0) {
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            
            if (para.triggerType) {
                para.triggerType=1;
            }else{
                para.triggerType=0;
            }

            addTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getTasks();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //开启job
    handleStartJob() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要操作的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认启动该Job吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { jobId: row.id };
          startJob(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getTasks();
          });
        })
        .catch(() => {});
    },
    //停止job
    handleStopJob() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要操作的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认停止该Job吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { jobId: row.id };
          stopJob(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getTasks();
          });
        })
        .catch(() => {});
    },
    //重启job
    handleReCoveryJob() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要操作的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认重启该Job吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { jobId: row.id };
          reCovery(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getTasks();
          });
        })
        .catch(() => {});
    },//暂停job
    handlePauseJob() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要操作的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认暂停该Job吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { jobId: row.id };
          pauseJob(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getTasks();
          });
        })
        .catch(() => {});
    },
    //恢复job
    handleResumeJob() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要操作的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认恢复该Job吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { jobId: row.id };
          resumeJob(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getTasks();
          });
        })
        .catch(() => {});
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { jobId: row.id };
          removeTask(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getTasks();
          });
        })
        .catch(() => {});
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getTasks();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
</style>
